import { render, staticRenderFns } from "./UpdateCourseRelationship.vue?vue&type=template&id=e2e2185e&scoped=true&"
import script from "./UpdateCourseRelationship.vue?vue&type=script&lang=js&"
export * from "./UpdateCourseRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e2185e",
  null
  
)

export default component.exports